/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { createJotaiVuexFacadeForReact } from "common/vue/createJotaiVuexFacadeForReact";
import { jotaiStore } from "./canvaModule.atoms";
import canvaModule from "./canvaModule";

const canvaStore = createJotaiVuexFacadeForReact({
  // @ts-expect-error TS(2322): Type 'Store' is not assignable to type 'JotaiStore... Remove this comment to see the full error message
  jotaiStore,
  state: {},
  stateKey: "canvaState",
  modules: {
    canva: canvaModule
  }
});

export default canvaStore;
